import React from 'react';
import { connect } from 'react-redux';
import PopUp from "../../../../../Shared/Popup/PopUp";
import {setCallsDetailsPopUp} from '../../../PersonalAreaInvoicesSlice';

 function CallDetailsPopUp(props) {
  let title = '';
  let text = '';
//   let linkText = '';

  switch (props.type) {
    case 'WithoutService':
      title = 'פירוט שיחות למנויים';
      text = 'פירוט השיחות זמין באתר עבור שלוש החשבוניות האחרונות';
      break;
    case 'NoCallsDetails':
        title = 'פירוט שיחות למנויים';
        text = 'לא נמצא פירוט שיחות להצגה';
      break;
    default:
      break;
  }

  return (
    <PopUp
    className='call-details-popup'
    showPopUp={props.showPopup}
    onClose={() => {
      props.setCallsDetailsPopUp({isDisplay: false});
    }}>
    <div className='content-wrapper'>
      <h2>{title}</h2>
      <p className='text'>{text}</p>
    </div>
    </PopUp>
  );
}

const mapStateToProps = (state) => {
  return {
    showPopup: state.personalAreaInvoicesPage.callsDetailsPage.showPopup,
    type : state.personalAreaInvoicesPage.callsDetailsPage.popupType
  };
};
const mapDispatchToProps = {
  setCallsDetailsPopUp
};

export default connect(mapStateToProps, mapDispatchToProps)(CallDetailsPopUp);

